module.exports = __webpack_public_path__ + "static/media/delete-program.e1cd0dcb.svg";